import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-2" }
const _hoisted_2 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Pool statistics ")
const _hoisted_4 = { class: "dark:bg-gray-850 rounded-lg p-2 mb-2" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-1050" }, "Created", -1)
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "text-gray-1050 text-sm" }
const _hoisted_9 = { class: "text-xs" }
const _hoisted_10 = { class: "dark:bg-gray-850 rounded-lg p-2 flex flex-col mb-2 space-y-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-1050" }, "Lifetime stats")
], -1)
const _hoisted_12 = { class: "flex justify-between pl-2 pool-statistics-border" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "font-extralight text-gray-1050" }, " Volume ", -1)
const _hoisted_14 = { class: "font-extralight text-gray-1050" }
const _hoisted_15 = { class: "flex justify-between pl-2 pool-statistics-border" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-extralight text-gray-1050" }, " Swap fees ", -1)
const _hoisted_17 = { class: "font-extralight text-gray-1050" }
const _hoisted_18 = { class: "flex justify-between pl-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "font-extralight text-gray-1050" }, " Swaps ", -1)
const _hoisted_20 = { class: "font-extralight text-gray-1050" }
const _hoisted_21 = { class: "dark:bg-gray-850 rounded-lg p-2 flex flex-col mb-2 space-y-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-1050" }, "24h volume")
], -1)
const _hoisted_23 = { class: "flex justify-between pl-2 pool-statistics-border" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "font-extralight text-gray-1050" }, " All-time high ", -1)
const _hoisted_25 = { class: "font-extralight text-gray-1050" }
const _hoisted_26 = { class: "dark:bg-gray-850 rounded-lg p-2 flex flex-col mb-2 space-y-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-1050" }, "Total liquidity")
], -1)
const _hoisted_28 = { class: "flex justify-between pl-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "font-extralight text-gray-1050" }, " All-time high ", -1)
const _hoisted_30 = { class: "font-extralight text-gray-1050" }
const _hoisted_31 = { class: "dark:bg-gray-850 rounded-lg p-2 flex flex-col mb-2 space-y-2" }
const _hoisted_32 = { class: "flex justify-between pl-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "font-extralight text-gray-1050" }, " Number of investors ", -1)
const _hoisted_34 = { class: "font-extralight text-gray-1050" }
const _hoisted_35 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Pool Info ")
const _hoisted_37 = { class: "dark:bg-gray-850 rounded-lg p-2 mb-2" }
const _hoisted_38 = { class: "flex justify-between items-center" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-1050 text-sm" }, "MPT symbol", -1)
const _hoisted_40 = { class: "text-xs" }
const _hoisted_41 = { class: "dark:bg-gray-850 rounded-lg p-2 mb-2" }
const _hoisted_42 = { class: "flex justify-between items-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-1050 text-sm" }, "Pool contract", -1)
const _hoisted_44 = { class: "pl-4 font-medium eth-address text-gray-1050 text-md text-pink-950" }
const _hoisted_45 = { class: "dark:bg-gray-850 rounded-lg p-2 mb-2" }
const _hoisted_46 = { class: "flex justify-between items-center" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-1050 text-sm" }, "Pool owner", -1)
const _hoisted_48 = { class: "pl-4 font-medium eth-address text-gray-1050 text-md text-pink-950" }
const _hoisted_49 = { class: "dark:bg-gray-850 rounded-lg p-2 mb-2" }
const _hoisted_50 = { class: "flex justify-between items-center" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-1050 text-sm" }, "Factory contract", -1)
const _hoisted_52 = { class: "pl-4 font-medium eth-address text-gray-1050 text-md text-pink-950" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalCard = _resolveComponent("BalCard")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_BalCard, {
        noPad: "",
        class: "p-2"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.JsTimeToDate(_ctx.poolQuery.data.value?.createTime).date), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.JsTimeToDate(_ctx.poolQuery.data.value?.createTime).fromNow), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.fNum(_ctx.poolQuery.data.value?.totalSwapVolume, 'usd')), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.fNum(_ctx.poolQuery.data.value?.totalSwapFee, 'usd')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.poolQuery.data.value?.swapsCount), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.fNum(_ctx.poolQuery.data.value?.volume24h, 'usd')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.fNum(_ctx.poolQuery.data.value?.totalLiquidity, 'usd')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.poolQuery.data.value?.holdersCount), 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _createVNode(_component_BalCard, {
        noPad: "",
        class: "p-2"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.pool22Query.data.value?.symbol), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createVNode(_component_BalLink, {
                href: _ctx.explorer.addressLink(_ctx.poolQuery.data.value?.id),
                external: "",
                noStyle: "",
                class: "flex items-center text-pink-950",
                style: {"z-index":"9999"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.shorten(_ctx.poolQuery.data.value?.id)), 1),
                  _createVNode(_component_BalIcon, {
                    name: "arrow-up-right",
                    size: "sm",
                    class: "ml-2 text-gray-200 hover:text-white transition-colors text-pink-950"
                  })
                ]),
                _: 1
              }, 8, ["href"])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createVNode(_component_BalLink, {
                href: _ctx.explorer.addressLink(_ctx.poolQuery.data.value?.owner),
                external: "",
                noStyle: "",
                class: "flex items-center text-pink-950",
                style: {"z-index":"9999"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.shorten(_ctx.poolQuery.data.value?.owner)), 1),
                  _createVNode(_component_BalIcon, {
                    name: "arrow-up-right",
                    size: "sm",
                    class: "ml-2 text-gray-200 hover:text-white transition-colors text-pink-950"
                  })
                ]),
                _: 1
              }, 8, ["href"])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createVNode(_component_BalLink, {
                href: _ctx.explorer.addressLink(_ctx.poolQuery.data.value?.factory),
                external: "",
                noStyle: "",
                class: "flex items-center text-pink-950",
                style: {"z-index":"9999"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.shorten(_ctx.poolQuery.data.value?.factory)), 1),
                  _createVNode(_component_BalIcon, {
                    name: "arrow-up-right",
                    size: "sm",
                    class: "ml-2 text-gray-200 hover:text-white transition-colors text-pink-950"
                  })
                ]),
                _: 1
              }, 8, ["href"])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}